import React from "react";
import { Skeleton } from "primereact/skeleton";

const CartLoading = () => {
    return (
        <div className="">
            <div className="flex mx-5">
                <Skeleton className="breadcrumb-skeleton" />
                <Skeleton className="breadcrumb-skeleton" />
                <Skeleton className="breadcrumb-skeleton" />
            </div>
            <div className="grid gap-3 grid-cols-1 sm:grid-cols-12 py-4">
                <div className="col-span-1 sm:col-span-8 space-y-2">
                    <div className="m-5">
                        <Skeleton className="cart-item-skeleton" />
                        <Skeleton className="cart-item-skeleton" />
                        <Skeleton className="cart-item-skeleton" />
                        <Skeleton className="cart-item-skeleton" />
                        <Skeleton className="cart-item-skeleton" />
                    </div>
                </div>
                <div className="col-span-1 sm:col-span-4">
                    <div className="m-5">
                        <Skeleton className="prod-details-name" />
                        <div className="mx-4">
                            <Skeleton className="prod-details-desc" />
                        </div>
                        <Skeleton className="prod-details-price" />
                        <Skeleton className="prod-details-vars" />
                        <div className="flex">
                            <Skeleton className="prod-details-qun" />
                            <Skeleton className="prod-details-cart-btn" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CartLoading;